import { Menu } from 'antd';
import { Route, Routes } from 'react-router-dom';
import { VideowallConfig } from './VideowallConfig';
import { Sidebar } from '../../SideBar';
import { useContentContext } from '../../../../contexts/ContentContext';
import { useState } from 'react';

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

export const Config = () => {
    const items = [
        getItem('Videowall', 'sub1', '', [
          getItem('General', '/videowallConfig'),
          getItem('Map', '2'),
        //   getItem('Submenu', 'sub3', null, [getItem('Option 7', '7'), getItem('Option 8', '8')]),
        ])
    ];
    const sidebarMenus = ['Account', 'Videowall'];
    const [selectedMenu, setSelectedMenu] = useState(0);
    // const { changeSidebar } = useContentContext(); 

    // useEffect(() => {
    //     changeSidebar(sidebarMenus);
    // }, []);
    const changeSelectedMenu = (selectedMenu) => {
        console.log('selectedMenu', selectedMenu);
        setSelectedMenu(selectedMenu);
    }

    return(
        <div style={{minHeight: '79vh', width: '100vw', display: 'flex', flexDirection: 'row'}}>
            <Sidebar sidebarMenus={sidebarMenus} changeSelectedMenu={changeSelectedMenu}/>
        </div>
    )
}